module.exports = __webpack_public_path__ + "bc4b99af8a90bc9c2686e1764c75df03.jpg";